import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'
import { createUseClasses } from '../common'
import { Post } from './post'

// constants

const ALL_POSTS = graphql`
  query {
    allSanityPost(sort: { date: DESC }) {
      edges {
        node {
          _id
          content {
            contentList {
              _key
              _rawRichContent
              html
            }
          }
          date(formatString: "YYYY.M.D")
          slug {
            current
          }
          title
        }
      }
    }
  }
`

// hooks

const useClasses = createUseClasses({
  post: { borderTop: '1px solid #e5e5e5', paddingTop: 16 }
})

// components

export const Posts = () => {
  const classes = useClasses()
  const { allSanityPost } = useStaticQuery(ALL_POSTS)

  return allSanityPost.edges.map(({ node: post }) => (
    <div className={classes.post} key={post._id}>
      <Post link={post.slug.current} post={post} />
    </div>
  ))
}
